import { IFontSize } from '../types';

export const fontSize: IFontSize = {
  headings: {
    H1: '5rem',
    H2: '3.5rem',
    H3: '2.5rem',
    H4: '2rem',
    H5: '1.75rem',
    H6: '1.5rem',
  },

  subtitle: {
    LARGE: '1.125rem',
    SMALL: '1rem',
  },

  body: {
    LARGE: '1rem',
    SMALL: '0.875rem',
  },

  button: {
    LARGE: '1.25rem',
    SMALL: '0.875rem',
  },

  caption: '0.8rem',
  overline: '0.625rem',
  link: '1rem',
};
